import { loadPreferences, updatePreferences } from "@/lib/api/preferences";

const KEY = "mySubjectIds";

export async function getMySubjects(userId: string): Promise<string[]> {
  const prefs = await loadPreferences(userId);
  const ids = prefs[KEY];
  return Array.isArray(ids) ? (ids as string[]) : [];
}

export async function setMySubjects(userId: string, ids: string[]): Promise<string[]> {
  const next = Array.from(new Set(ids));
  const prefs = await updatePreferences(userId, (current) => ({
    ...current,
    [KEY]: next,
  }));
  const stored = prefs[KEY];
  return Array.isArray(stored) ? (stored as string[]) : [];
}

export async function addMySubject(userId: string, id: string): Promise<string[]> {
  const current = await getMySubjects(userId);
  if (current.includes(id)) return current;
  return setMySubjects(userId, [...current, id]);
}

export async function removeMySubject(userId: string, id: string): Promise<string[]> {
  const current = await getMySubjects(userId);
  return setMySubjects(userId, current.filter((x) => x !== id));
}

export async function isInMySubjects(userId: string, id: string): Promise<boolean> {
  const current = await getMySubjects(userId);
  return current.includes(id);
}